// firebaseConfig.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from "firebase/firestore";
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';
import { getMessaging, isSupported } from "firebase/messaging"; // Importamos isSupported

const firebaseConfig = {
    apiKey: "AIzaSyCZdmXEtClZuU5nZJaa1nb3cT3C5XfCCIU",
    authDomain: "ecommerce-acf03.firebaseapp.com",
    projectId: "ecommerce-acf03",
    storageBucket: "ecommerce-acf03.appspot.com",
    messagingSenderId: "211023368893",
    appId: "1:211023368893:web:03d08ab7a539351e8d9dd4",
    measurementId: "G-T4VNE7WBVK"
};

const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);

// --- CAMBIO AQUÍ ---
// Inicializamos messaging de forma asíncrona o protegida
let messaging = null;

// Esta función verifica si el entorno soporta mensajería antes de tronar la app
const initializeMessaging = async () => {
    try {
        const supported = await isSupported();
        if (supported) {
            return getMessaging(firebaseApp);
        }
        return null;
    } catch (err) {
        console.error("FCM no es soportado en este entorno", err);
        return null;
    }
};

// Intentamos obtenerlo
initializeMessaging().then(m => messaging = m);
// -------------------

export { auth, db, createUserWithEmailAndPassword, signInWithEmailAndPassword, messaging };